// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  clientId: 'RABMOA',
  issuer: 'https://mylogin-stg.web.bpifrance.fr:443/am/oauth2',
  tokenEndpoint: 'https://mylogin-stg.web.bpifrance.fr:443/am/oauth2/access_token',
  loginUrl: 'https://mylogin-stg.web.bpifrance.fr:443/am/oauth2/authorize',
  userinfoEndpoint: 'https://mylogin-stg.web.bpifrance.fr:443/am/oauth2/userinfo',
  apiUrl: 'https://apiv2-nprd.cloud.bpifrance.fr/dev/rab/rest/rab/v1',
  apiKey: 'dev_rab_23145d0e75aa33b1347301f741618f5a65f2bc6f',
  rabUrls: {
    brcUrl: '/budgetary-responsibility-centers',
    asUrl: '/analytical-sections',
    uoUrl: '/organizational-units'
  },
  paginationConfig : {
    defaultPageSize: 20
  }
};
